<template>
    <v-container fluid>
        <br>
        <h2 class="text-center" style="font-family: Avenir1;"> Accredited Partners </h2>
        <br>
        <v-row class="mt-5" justify="center" :style="$vuetify.breakpoint.width < 750 ? 'display: block;' : ''">
            <v-col align="center">
            <v-img
            src="@/assets/IWM.png"
            alt="Institute of Waste Management"
            max-width="90"
            contain
            class="mb-1"
            />
            <br/>
            <p class="main--text text-justify-center par"> Institute of Waste Management since 2009 </p>
            </v-col>
            <v-col align="center" class="img">
            <v-img
            src="@/assets/City of Cape Town.png"
            alt="City of Cape Town"
            max-width="150"
            contain
            />
            <br/>
            <p class="main--text text-justify-center par"> Accredited City of Cape Town Provider since 2016 </p>
            </v-col>
            <v-col align="center">
            <v-img
            src="@/assets/MBA.png"
            alt="Master Builders and Allied Traders Association"
            max-width="98"
            contain
            class="mt-n2"
            />
            <br/>
            <p class="main--text text-justify-center par"> Master Builders and Allied Traders' Association since 2021 </p>
            </v-col>
            <v-col align="center">
            <a href="https://umthi.africa/" target="_blank" ref='noopener noreferral'>
              <v-img
              src="@/assets/Umthi.png"
              alt="Umthi Initiatives"
              max-width="74"
              contain
              class="mt-n2"
              />
            </a>
            <br/>
            <p class="main--text text-justify-center par"> Umthi Initiatives since 2020 </p>
            </v-col>
            <v-col align="center">
            <v-img
            src="@/assets/PeachLogo.png"
            alt="Peach Payments"
            max-width="105"
            contain
            class="mb-5"
            />
            <br/>
            <p class="main--text text-justify-center par"> Peach Payments gateway since 2007 </p>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'Partners',
    data() {
       return {

       }
    },
}
</script>
